"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RootDIProvider = exports.makeServiceIdentifier = void 0;
var inversify_1 = require("inversify");
var inversify_react_1 = require("inversify-react");
var react_1 = __importDefault(require("react"));
var makeServiceIdentifier = function (symbol) { return ({ $: symbol }); };
exports.makeServiceIdentifier = makeServiceIdentifier;
var recursivelyBindInversifyToHeroin = function (container, di) {
    var e_1, _a;
    var heroinBindings = Object.keys(__assign(__assign({}, di.providers), di.values));
    var _loop_1 = function (binding) {
        if (!container.isBound(binding)) {
            container.bind(binding).toDynamicValue(function () { return di.get(binding); });
        }
    };
    try {
        for (var heroinBindings_1 = __values(heroinBindings), heroinBindings_1_1 = heroinBindings_1.next(); !heroinBindings_1_1.done; heroinBindings_1_1 = heroinBindings_1.next()) {
            var binding = heroinBindings_1_1.value;
            _loop_1(binding);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (heroinBindings_1_1 && !heroinBindings_1_1.done && (_a = heroinBindings_1.return)) _a.call(heroinBindings_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    if (di.parent) {
        return recursivelyBindInversifyToHeroin(container, di.parent);
    }
};
var RootDIProvider = function (_a) {
    var di = _a.di, children = _a.children;
    return (react_1.default.createElement(inversify_react_1.Provider, { container: function () {
            var container = new inversify_1.Container();
            if (di) {
                recursivelyBindInversifyToHeroin(container, di);
            }
            return container;
        } }, children));
};
exports.RootDIProvider = RootDIProvider;
var DIProvider = inversify_react_1.Provider;
exports.default = DIProvider;
